<template>
  <div class="InfiniteLoadingListContainer">
    <nut-infiniteloading
        :has-more="hasMore"
        @load-more="loadMore"
        @refresh="refresh"
        load-icon="loading"
        pull-icon="loading"
        :load-more-txt="loadMoreText"
        :is-open-refresh="true"
    >
      <template v-for="(p,i) in list" :key="i">
        <slot :data="p"/>
      </template>

      <div v-if="list.length<1" class="bothCenter colFlex" style="width: 100%">
        <img  style="width: 40%" src="https://cdn.waityou.online/5be1d65f-64a0-a13b-125d-255257564901.png"/>
<!--        <span class="miniFont" style="color:rgba(211,211,211)">没有更多数据</span>-->
      </div>
    </nut-infiniteloading>

    <nut-backtop :distance="200" ></nut-backtop>
  </div>
</template>

<script>
import api from "@/api"

export default {
  name: "InfiniteLoadingList",
  props: {
    loadMoreText: {
      type: String,
      default: '没有更多数据了'
    },
    method: {
      type: String,
      default: 'GET'
    },
    queryId: {
      type: Number,
      default: 0,
    },
    initQuery: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  watch: {
    initQuery() {
      this.refresh()
    }
  },
  data() {
    return {
      hasMore: false,
      page: 0,
      pageSize: 10,
      list: [],
    }
  },
  methods: {
    refresh(done) {
      this.hasMore = true;
      this.page = 0;
      this.list = [];
      this.loadMore(done)
    },
    loadMore(done) {
      let query = {
        page: this.page,
        pageSize: this.pageSize
      }
      for(let k of Object.keys(this.initQuery)){
        query[k] = this.initQuery[k];
      }
      api.getInfiniteLoadingList(this.queryId, this.method, query)
          .then(ret => {
            if (ret.list) {
              for (let o of ret.list) {
                this.list.push(o)
              }
            }
            if (!ret || ret.list.length < this.pageSize) {
              this.hasMore = false;
            }
            this.page += 1;
          })
          .finally(() => {
            if (done) {
              done();
            }
          })
    }
  },
  mounted() {
    this.refresh()
  }
}
</script>

<style lang="scss" scoped>
.InfiniteLoadingListContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
</style>